var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.html)?_vm._m(0):_vm._m(1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('htmlWrapper',{ref:"htmlContent",staticClass:"html-content",attrs:{"themeColor":_vm.theme,"role":"content"},domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":_vm.handleClicks}})
},function (){var _vm=this,_c=_vm._self._c;return _c('htmlWrapper',{ref:"htmlContent",staticClass:"html-content",attrs:{"themeColor":_vm.theme,"role":"content"},domProps:{"innerHTML":_vm._s(_vm.htmlSlot)},on:{"click":_vm.handleClicks}})
}]

export { render, staticRenderFns }